<template>
    <div id="app">
        <application-header v-if="$route.path !== '/' || $route.name !=='login'" />
        <notifications group="info" classes="vue-notification" position="top center" :speed="500" />
        <div v-if="loginAgain" class="modal-mask login-modal">
            <div class="modal-wrapper flexbox-center">
                <div class="modal-container">
                    <div class="modal-body">
                        <div class="modal-header">
                            <h2 class="text-center">Log ind</h2>
                        </div>
                        <p class="text-center">Du har været inaktiv for længe.<br />
                        Af sikkerhedsmæssige årsager skal du indtaste din adgangskode igen.</p>
                        <form class="login-container" v-on:submit.prevent="onSubmit">
                            <div class="input-svg">
                                <icon class="locked small-svg" name="locked" />
                                <input type="password" class="password" placeholder="Adgangskode" autofocus v-model="password" @click.stop>
                            </div>
                            <div class="modal-footer">
                                <div class="text-center modal-buttons">
                                    <button type="submit" class="button-green">{{ loginMessage }}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import applicationHeader from './components/shared/header/application-header.vue'

export default {
    name: 'app',
    data () {
        return {
            loginMessage: 'Log ind',
            password: ''
        }
    },
    components: {
        'application-header': applicationHeader
    },
    computed: {
        ...mapGetters({
            loginAgain: 'getLoginAgain',
            user: 'user'
        })
    },
    methods: {
        ...mapActions({
            setIsDesktop: 'setIsDesktop',
            setLoginAgain: 'setLoginAgain',
            login: 'login'
        }),

        detectTouch () {
            let isTouch = false

            if ('ontouchstart' in window && 'orientation' in window && window.matchMedia('(pointer: coarse)').matches) {
                isTouch = true
            }

            return isTouch
        },
        onSubmit () {
            if (this.password.trim() !== '') {
                this.loginMessage = 'Logger ind...'
                let user = {
                    username: this.user.username,
                    password: this.password,
                    rememberme: false
                }
                this.login(user).then(response => {
                    this.setLoginAgain(false)
                }, error => {
                    this.loginMessage = 'Fejl i login'
                    setTimeout(() => {
                        this.loginMessage = 'Log ind'
                    }, 2500)
                    throw error
                })
            }
        }
    },
    created () {
        if (window.innerWidth < window.innerHeight) {
            this.setIsDesktop(false)
        } else {
            this.setIsDesktop(true)
        }
    },
    mounted () {
        const root = document.documentElement

        document.addEventListener('mousemove', (event) => {
            if (!this.detectTouch()) {
                const x = event.clientX / innerWidth
                const y = event.clientY / innerHeight

                root.style.setProperty('--mouse-x', x.toFixed(3))
                root.style.setProperty('--mouse-y', y.toFixed(3))
            }
        })
    }
}
</script>

<style lang="scss">
    @import './scss/main';

    .login-modal {
        .modal-container {
            background-color: #f9f9f9;
        }
    }

    .login-container {
        margin-top: 30px;
        width: 350px;
        margin-left: auto;
        margin-right: auto;

        .input-svg {
            position: relative;

            svg {
                position: absolute;
                left: 15px;
                top: 15px;
                bottom: 0;
                fill: #82868d;
            }

            input {
                height: 50px;
                padding-left: 50px;
                border: 0;
                width: 350px;
                box-shadow: 0px 2px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.07), 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue